import $ from 'jquery';
import URI from 'urijs';
import './toggleview';

function filters() {
    var list = $(".infotable .event");
    var technology = $("#select-technology").val() || undefined;
    var topic = $("#select-topic").val() || undefined;
    var subjectarea = $("#select-subjectarea").val() || undefined;
    var url = window.location.href;
    var title = "";
    $(list).fadeOut("fast");  
    
    if(!subjectarea && !technology && !topic) {
        $(list).slideDown("fast");    
    }
    else{
        var filterTechnology = "", filterTopic="", filterSubjectArea="";
        if(technology){
            filterTechnology = '[data-technology*="'+technology+'"]';
            title = technology.toString();
        }
        if(topic){
            filterTopic = '[data-topic*="'+topic+'"]';
            title += " " +topic;
        }
        if(subjectarea){
            filterSubjectArea = '[data-subjectarea*="'+subjectarea+'"]';
            title += " " +subjectarea;        
        }
        $(".infotable").find('.event' + filterTechnology + filterTopic + filterSubjectArea).each(function(i){
            $(this).delay(200).slideDown("fast");
        }); 
    }     
    history.pushState('Workshops', title, URI().setQuery( { topic, technology, subjectarea } ).toString() );
}



$(function(){
  //Filter for workshops
  $('.select-events #select-technology').on('change', function() {
    //var filter = $(this).val();    
    filters();   
  });
  $('.select-events #select-topic').on('change', function() {
    //var filter = $(this).val();   
    filters();
  });
  $('.select-events #select-subjectarea').on('change', function () {
    //var filter = $(this).val();
    filters();
  });
  if ($(".search-infotable").length) {
	var { technology: urlTechnology, topic: urlTopic, subjectarea: urlSubjectArea } = URI().query(true) as any;
    // console.log(urlTechnology, urlTopic);
    $('#select-technology option[value="' +urlTechnology+'"]').attr("selected", "selected");
    $('#select-topic option[value*="' + urlTopic + '"]').attr("selected", "selected");
    $('#select-subjectarea option[value*="' + urlSubjectArea + '"]').attr("selected", "selected");
    filters();
  }
});